module.exports = "/assets/site/images/Laser-rajt.jpg?9c9bb9360d4331c49986f05bc8c53a2e";